import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LoginContainer from './login/LoginContainer';
import ForgotPasswordComponent from './ResetPassword/ForgotPassword';
import SetPassword from './ResetPassword/SetPassword';
import * as UserLoginActions from './UserLoginActions';
import {
    LOGIN_COMPONENT,
    FORGOT_PASSWORD,
    SET_PASSWORD
} from './UserLoginActionTypes';

const UserLoginContainer = ({ enterprise, social, register }) => {
    const { visibleComponent, email } = useSelector(state => state.userLogin);

    const dispatch = useDispatch();

    const userLoginActions = Object.entries(UserLoginActions).reduce(
        (actions, [name, action]) => {
            const newActions = { ...actions };

            newActions[name] = (...args) => dispatch(action(...args));

            return newActions;
        },
        {}
    );

    switch (visibleComponent) {
        case LOGIN_COMPONENT:
            return (
                <LoginContainer
                    enterprise={enterprise}
                    social={social}
                    userLogin={userLoginActions}
                    register={register}
                />
            );
        case FORGOT_PASSWORD:
            return <ForgotPasswordComponent userLogin={userLoginActions} />;
        case SET_PASSWORD:
            return <SetPassword userLogin={userLoginActions} email={email} />;
        default:
            return <div />;
    }
};

UserLoginContainer.propTypes = {
    register: PropTypes.number,
    social: PropTypes.number,
    enterprise: PropTypes.number
};

UserLoginContainer.defaultProps = {
    register: 0,
    social: 0,
    enterprise: 0
};

export default UserLoginContainer;
